import { m } from '@pricedrop/i18n';
import { Button } from '@/components/ui/button';

export function RateLimitPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-8 px-4 py-16 text-center">
      <div className="text-[5rem] leading-none" aria-hidden="true">
        🚦
      </div>

      <div className="max-w-md space-y-3">
        <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl md:text-5xl">
          {m.rateLimit_title()}
        </h1>
        <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">
          {m.rateLimit_description()}
        </p>
      </div>

      <div className="w-full max-w-sm">
        <div className="rounded-2xl border-2 border-dashed border-border bg-muted/40 px-6 py-5">
          <p className="text-sm leading-relaxed text-muted-foreground">
            {m.rateLimit_proTipBody()}
          </p>
          <Button
            size="lg"
            className="mt-4 w-full"
            onClick={() => window.dispatchEvent(new Event('auth:required'))}
          >
            {m.rateLimit_signIn()}
          </Button>
        </div>
      </div>

      <Button variant="outline" size="lg" onClick={() => window.location.reload()}>
        {m.rateLimit_tryAgain()}
      </Button>
    </div>
  );
}
